import React from 'react';
import ImageUploader from './components/Check_Image_Tag';
import Form from "./components/Form";
const index = () => {
  return (
<Form  />
  )
}

export default index
